import { useMemo } from 'react';

import { useCampaignInfoByProvider } from '#api/new/campaigns/utils/campaignUtils.js';
import { PeerTypes, useShowConsumerCampaignSettingsById } from '@givebacks/api/store';
import { AwardIcon } from 'core/Components';
import { Avatar, Box, Skeleton } from 'ui';

import classNames from './CrowdFundingAvatar.module.css';

const CrowdFundingAvatar = ({
  img,
  name,
  place,
  isLoading,
  size,
  peerType,
}: {
  img?: string;
  name?: string;
  place?: number | string;
  isLoading: boolean;
  size?: number | string;
  peerType: PeerTypes;
}) => {
  const { causeId, campaignId } = useCampaignInfoByProvider();
  const { data: settings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });

  const isParticipantLeaderboardInCenterEnabled = settings?.isParticipantLeaderboardInCenterEnabled;
  const isTeamLeaderboardInCenterEnabled = settings?.isTeamLeaderboardInCenterEnabled;

  const isLeaderboardInCenterEnabled = useMemo(() => {
    if (peerType === 'participants') {
      return isParticipantLeaderboardInCenterEnabled;
    } else if (peerType === 'teams') {
      return isTeamLeaderboardInCenterEnabled;
    }
    return false;
  }, [peerType, isParticipantLeaderboardInCenterEnabled, isTeamLeaderboardInCenterEnabled]);

  return (
    <Skeleton visible={isLoading} w={size ?? 62}>
      <Box
        pos={'relative'}
        w={size ?? 62}
        h={size ?? 62}
        className={classNames['CrowdFundingAvatar__avatar-container']}
        mod={{
          place: isLeaderboardInCenterEnabled ? place : undefined,
        }}
      >
        <Avatar
          src={img}
          size={size ?? 56}
          radius={'xl'}
          color="cobalt.5"
          classNames={{
            root: classNames.CrowdFundingAvatar__avatar,
            image: classNames.CrowdFundingAvatar__image,
          }}
          name={name}
        />

        {isLeaderboardInCenterEnabled && place && (
          <Box w={24} style={{ position: 'absolute', bottom: -8.5, margin: 'auto' }}>
            <AwardIcon place={Number(place)} />
          </Box>
        )}
      </Box>
    </Skeleton>
  );
};

export { CrowdFundingAvatar };
